import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Box,
  Typography,
  Autocomplete,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useParams } from "react-router-dom";
import {
  createStakeHolderBySiteId,
  deleteStakeholderById,
  getStakeholdersByCompany,
} from "../../services/siteServices/stakeholderServices";
import { getSiteById } from "../../services/siteServices/subSiteService";
import { getAllCompany } from "../../services/siteServices/companyServices";
import DynamicTable from "./DynamicTable";
import AppConfig from "../../config";
import { validateFields } from "../../helpers/utils";
import SnackBars from "../snackbars/SnackBars";
// import { Phone } from "@mui/icons-material";

const theme = createTheme({
  typography: {
    fontSize: 12,
  },
  components: {
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
    },
    MuiSelect: {
      defaultProps: {
        variant: "outlined",
        size: "small",
      },
    },
    MuiButton: {
      defaultProps: {
        size: "small",
      },
    },
  },
});

const StakeHolderDetailsTable = ({ projectCode }) => {
  const { id } = useParams();
  const [stakeholders, setStakeholders] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [companies, setCompanies] = useState([]);

  const [newStakeholder, setNewStakeholder] = useState({
    id: null,
    name: "",
    email: "",
    mobileNumber: "",
    designation: "",
    role: "",
    companyId: "",
    companyName: "",
    companyStakeholder: "",
  });

  const [errors, setErrors] = useState({
    role: false,
    companyName: false,
    name: false,
    email: false,
    mobileNumber: false,
  });

  const [inputs, setInputs] = useState({ email: "", mobileNumber: "" });

  const [selectedCompanyStakeholders, setSelectedCompanyStakeholders] =
    useState([]);

  const [roles] = useState([
    { value: "sil_approver", title: "SIL Approver" },
    {
      value: "sil_coordinator_for_authority",
      title: "SIL Coordinator for Authority",
    },
    { value: "sil_escalation_to", title: "SIL Escalation to" },
    { value: "principle_official", title: "Principle official" },
  ]);

  // useEffect(() => {
  //   console.log("newStakeholder", newStakeholder);
  // }, [newStakeholder]);

  const getRoleTitle = (value) => {
    const role = roles.find((role) => role.value === value);
    return role?.title || "-";
  };

  const getAllStakeHolders = async (url) => {
    const res = await getSiteById(url);
    const temp = res.StakeHoldersDetails.map((item, index) => ({
      StakeHolderID: item.StakeHolderID,
      id: index + 1,
      name: item.Name,
      email: item.Email || "-",
      mobileNumber: item.ContactNumber || "-",
      designation: item.Designation || "-",
      role: getRoleTitle(item.DesignatedFor) || "-",
    }));
    setStakeholders(temp);
  };

  const fetchAllCompanies = async () => {
    try {
      const principleResponse = await getAllCompany();

      if (newStakeholder.role.split("_")[0] == "sil") {
        const filteredPrincipleResponse = principleResponse.filter(
          (item, index) => {
            if (item.company_name == "SIL") {
              return item;
            }
          }
        );
        setCompanies(filteredPrincipleResponse);
      } else {
        const filteredPrincipleResponse = principleResponse.filter(
          (item, index) => {
            if (item.company_name == projectCode.split("-")[0]) {
              return item;
            }
          }
        );
        setCompanies(filteredPrincipleResponse);
      }
    } catch (error) {
      console.log("error in fetchCities", error);
    }
  };

  useEffect(() => {
    getAllStakeHolders(id);
    fetchAllCompanies();
  }, [newStakeholder.role]);

  const handleOpenAddDialog = () => {
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
    setNewStakeholder({
      id: null,
      name: "",
      email: "",
      mobileNumber: "",
      designation: "",
      role: "",
      companyName: "",
      companyStakeholder: "",
    });
  };

  const handleAddStakeholder = async () => {
    try {
      if (!newStakeholder.role) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          role: "role is required",
        }));
        return;
      }
      if (!newStakeholder.companyName) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          companyName: "Company is required",
        }));
        return;
      }
      if (!newStakeholder.name) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          name: "name is required",
        }));
        return;
      }

      const postData = {
        Name: newStakeholder.name,
        Designation: newStakeholder.designation,
        ContactNumber: newStakeholder.mobileNumber,
        Email: newStakeholder.email,
        DesignatedFor: newStakeholder.role,
        created_by: "user",
      };

      // console.log("postData", postData);

      await createStakeHolderBySiteId(id, postData);
      getAllStakeHolders(id);
      handleCloseAddDialog();
      setOpenSnackBar(true);
      setSnackBarMessage({
        title: "Stakeholder added succesfully",
        type: "success",
      });
    } catch (error) {
      console.log("handleAddStakeholder making error", error);
    }
  };

  const handleDeleteStakeholder = async (StakeHolderID) => {
    try {
      console.log("StakeHolderID", StakeHolderID);
      const deletedStakeHolder = await deleteStakeholderById(StakeHolderID);
      console.log("StakeHolderID", StakeHolderID);
      getAllStakeHolders(id);

      setOpenSnackBar(true);
      setSnackBarMessage({
        title: "Stakeholder deleted succesfully",
        type: "success",
      });
    } catch (error) {
      console.log("handleDeleteStakeholder making error", error);
    }
  };

  const handleCompanyChange = async (event) => {
    const selectedCompany = event.target.value;
    const { name } = event.target;
    setNewStakeholder((prevState) => ({
      ...prevState,
      companyName: selectedCompany,
      companyStakeholder: "",
    }));
    const stakeholders = await getStakeholdersByCompany(selectedCompany);
    setSelectedCompanyStakeholders(stakeholders);
    validateFields(name, selectedCompany, setErrors);
  };

  const handleChange = (field) => (event) => {
    const { value } = event.target;
    setNewStakeholder((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    validateFields(field, value, setErrors);
  };

  const handleAutocomplete = (event, newValue) => {
    const { name, value } = event.target;
    validateFields(name, value, setErrors);

    event.preventDefault();
    if (newValue) {
      setNewStakeholder((prevState) => ({
        ...prevState,
        companyStakeholder: newValue.name,
        name: newValue.PersonName,
        email: newValue.EmailID || "",
        mobileNumber: newValue.ContactNumber || "",
        designation: newValue.PersonDesignation || "",
      }));
    } else {
      setNewStakeholder((prevState) => ({
        ...prevState,
        companyStakeholder: "",
        name: "",
        email: "",
        mobileNumber: "",
        designation: "",
      }));
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "StakeHolderID",
        header: "Action",
        size: 50,
        Cell: ({ row }) => (
          <Typography
            sx={{
              cursor: "pointer",
              fontSize: "14px",
              color: "#1976D2",
              "&:hover": {
                color: "#1976D2",
              },
            }}
            onClick={() => handleDeleteStakeholder(row.original.StakeHolderID)}
          >
            <DeleteIcon sx={{ color: AppConfig.colorPalette.error.dark }} />
          </Typography>
        ),
      },

      {
        accessorKey: "id",
        header: "Serial No",
        size: 50,
      },
      {
        accessorKey: "name",
        header: "Name",
        size: 100,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 100,
      },
      {
        accessorKey: "mobileNumber",
        header: "Mobile Number",
        size: 100,
      },
      {
        accessorKey: "designation",
        header: "Designation",
        size: 100,
      },
      {
        accessorKey: "role",
        header: "Role",
        size: 100,
      },
    ],
    []
  );

  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState({
    title: "",
    type: "",
  });

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: "100%", margin: "auto" }}>
        {stakeholders.length > 0 ? (
          <DynamicTable columns={columns} data={stakeholders} />
        ) : (
          <Typography>
            No stakeholders have been added yet. Please click here to add
            stakeholders.
          </Typography>
        )}

        {/* Add New Stackholder Dialog */}

        {/* Button to trigger the dialog */}
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenAddDialog}
          sx={{ margin: "16px 0", backgroundColor: "#b41660", color: "#fff" }}
        >
          Add New Stakeholder
        </Button>

        {/* adding dialog */}
        <Dialog
          maxWidth="sm"
          open={openAddDialog}
          onClose={handleCloseAddDialog}
          fullWidth
        >
          <DialogTitle>Add New Stakeholder</DialogTitle>
          <DialogContent>
            <FormControl fullWidth margin="normal">
              <InputLabel id="role-label">
                Role
                <Typography
                  component="span"
                  sx={{ color: "red", marginLeft: "4px" }}
                >
                  *
                </Typography>
              </InputLabel>
              <Select
                fullWidth
                name="role"
                label="Role"
                labelId="role-label"
                value={newStakeholder.role}
                onChange={handleChange("role")}
                sx={{
                  paddingBottom: "10px",
                  height: "3rem",
                }}
              >
                {roles.map((role) => (
                  <MenuItem key={role.value} value={role.value}>
                    {role.title}
                  </MenuItem>
                ))}
              </Select>
              {errors.role && (
                <Typography variant="caption" color="error">
                  Role is required
                </Typography>
              )}
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel id="company-label">
                Company{" "}
                <Typography
                  component="span"
                  sx={{ color: "red", marginLeft: "4px" }}
                >
                  *
                </Typography>
              </InputLabel>
              <Select
                name="companyName"
                label="Company"
                labelId="company-label"
                value={newStakeholder.companyName}
                onChange={handleCompanyChange}
                disabled={newStakeholder.role ? false : true}
                sx={{
                  paddingBottom: "10px",
                  height: "3rem",
                }}
              >
                {companies.map((company) => (
                  <MenuItem
                    key={company.company_id}
                    value={company.company_name}
                  >
                    {company.company_name}
                  </MenuItem>
                ))}
              </Select>
              {errors.companyName && (
                <Typography variant="caption" color="error">
                  Company is required
                </Typography>
              )}
            </FormControl>

            {selectedCompanyStakeholders.length > 0 ? (
              <FormControl fullWidth margin="normal">
                <Autocomplete
                  options={selectedCompanyStakeholders}
                  getOptionLabel={(option) => option.PersonName}
                  onChange={handleAutocomplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="name"
                      label="Stakeholder Name"
                      variant="outlined"
                    />
                  )}
                />
                {errors.name && (
                  <Typography variant="caption" color="error">
                    Stakeholder Name is required
                  </Typography>
                )}
              </FormControl>
            ) : (
              <TextField
                display={"hidden"}
                fullWidth
                label="Stakeholder Name"
                value={newStakeholder.name}
                margin="normal"
                onChange={handleChange("name")}
              />
            )}
            {/* <TextField
              fullWidth
              label="Email"
              value={newStakeholder.email}
              margin="normal"
              onChange={handleChange("email")}
            /> */}
            {/* <TextField
              fullWidth
              label="Email"
              value={inputs.email}
              margin="normal"
              error={errors.email}
              helperText={
                errors.email ? "Please enter a valid email address" : ""
              }
              onChange={(event) => {
                const value = event.target.value;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                setInputs((prev) => ({ ...prev, email: value }));
                setErrors((prev) => ({
                  ...prev,
                  email: value !== "" && !emailRegex.test(value),
                }));
              }}
            /> */}
            <TextField
              fullWidth
              label="Email"
              value={newStakeholder.email}
              margin="normal"
              error={errors.email}
              helperText={
                errors.email ? "Please enter a valid email address" : ""
              }
              onChange={(event) => {
                const value = event.target.value;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                // Update newStakeholder.email
                setNewStakeholder((prev) => ({
                  ...prev,
                  email: value,
                }));

                // Validate email and set error state
                setErrors((prev) => ({
                  ...prev,
                  email: value !== "" && !emailRegex.test(value),
                }));
              }}
            />

            {/* <TextField
              fullWidth
              label="Mobile Number"
              value={newStakeholder.mobileNumber}
              margin="normal"
              onChange={handleChange("mobileNumber")}
            /> */}
            {/* <TextField
              fullWidth
              label="Mobile Number"
              value={inputs.phone}
              margin="normal"
              error={errors.phone}
              helperText={
                errors.phone ? "Please enter a valid 10-digit phone number" : ""
              }
              onChange={(event) => {
                const value = event.target.value;
                const phoneRegex = /^[0-9]{0,10}$/;
                setInputs((prev) => ({ ...prev, phone: value }));
                setErrors((prev) => ({
                  ...prev,
                  phone: value !== "" && !phoneRegex.test(value),
                }));
              }}
              inputProps={{
                maxLength: 10, // Limits input to 10 characters
              }}
            /> */}

            {/* <TextField
              fullWidth
              label="Mobile Number"
              value={newStakeholder.mobileNumber}
              margin="normal"
              error={errors.phone}
              helperText={
                errors.phone ? "Please enter a valid 10-digit phone number" : ""
              }
              onChange={(event) => {
                const value = event.target.value;
                const phoneRegex = /^[0-9]{0,10}$/;

                // Update newStakeholder.phone
                setNewStakeholder((prev) => ({
                  ...prev,
                  phone: value,
                }));

                // Validate phone and set error state
                setErrors((prev) => ({
                  ...prev,
                  phone: value !== "" && !phoneRegex.test(value),
                }));
              }}
              inputProps={{
                maxLength: 10, // Limits input to 10 characters
              }}
            /> */}
            <TextField
              fullWidth
              label="Mobile Number"
              value={newStakeholder.mobileNumber}
              margin="normal"
              error={errors.mobileNumber}
              type="number"
              helperText={
                errors.mobileNumber
                  ? "Please enter a valid 10-digit phone number"
                  : ""
              }
              onChange={(event) => {
                const value = event.target.value;
                const phoneRegex = /^[0-9]{0,10}$/;

                // Update newStakeholder.mobileNumber
                setNewStakeholder((prev) => ({
                  ...prev,
                  mobileNumber: value,
                }));

                // Validate mobileNumber and set error state
                setErrors((prev) => ({
                  ...prev,
                  mobileNumber: value !== "" && !phoneRegex.test(value),
                }));
              }}
              inputProps={{
                maxLength: 10, // Limits input to 10 characters
              }}
            />

            <TextField
              fullWidth
              label="Designation"
              value={newStakeholder.designation}
              margin="normal"
              onChange={handleChange("designation")}
            />
          </DialogContent>
          <DialogActions>
            <Button sx={{ color: "#000" }} onClick={handleCloseAddDialog}>
              Cancel
            </Button>
            <Button
              onClick={handleAddStakeholder}
              sx={{ backgroundColor: "#b41660", color: "#fff" }}
              variant="contained"
            >
              Add
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      <SnackBars
        open={openSnackBar}
        setOpen={setOpenSnackBar}
        handleClose={handleCloseSnackBar}
        title={snackBarMessage.title}
        type={snackBarMessage.type}
      />
    </ThemeProvider>
  );
};

export default StakeHolderDetailsTable;

// const [openSnackBar, setOpenSnackBar] = useState(false);
//   const [snackBarMessage, setSnackBarMessage] = useState({
//     title: "Stakeholder added succesfully",
//     type: "success",
//   });
